// universignSigInit is loaded via ERB in the drawer partial
// (see `Rails.configuration.universign_iframe_endpoint/sig/embed.js`).
// This function assumes `universignSigInit` is already available on window.

export function initSignature(containerId, signerId, endpoint) {
  // TODO(fiscality): switch back to 'IN' once the cross-site session on the
  // callback is handled (controller outside authenticate :user, skip the
  // before_action of ApplicationController that redirects to sign_in when
  // no user). In 'IN' the drawer stays open, success step shows and the
  // block refreshes without reload. For now: 'OUT' redirects the full page
  // to users_fiscality_path (reload).
  const configuration = { redirectionMode: 'OUT' };
  // eslint-disable-next-line no-undef
  universignSigInit(containerId, signerId, configuration, endpoint);
}
